import React, { HTMLInputTypeAttribute } from 'react'

interface P {
    type: HTMLInputTypeAttribute
    multiple?: boolean
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
}

function VisuallyHiddenInput({ type, multiple, onChange }: P) {
    return (
        <input
            type={type}
            style={{
                clip: 'rect(0 0 0 0)',
                clipPath: 'inset(50%)',
                height: 1,
                overflow: 'hidden',
                position: 'absolute',
                bottom: 0,
                left: 0,
                whiteSpace: 'nowrap',
                width: 1
            }}
            multiple={multiple}
            onChange={onChange}
        />
    )
}

export default VisuallyHiddenInput
